import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import React from "react";

// Assets
import carLogo from "../../assets/images/my_digital_car.svg";

// Core Components
import MDCButton from "../core/MDCButton";
import MDCModal from "../core/MDCModal";

// Icons
import ErrorFilterIcon from "../iconComponents/ErrorFilterIcon";
import SuccessTickIcon from "../iconComponents/SuccessTickIcon";
import YellowWarningIcon from "../iconComponents/YellowWarningIcon";
import theme from "../../themes/mdc-theme";

//Constants
import { GLOBAL_MESSAGE_STATUS } from "../../constants/GlobalConstants";

const useStyles = makeStyles((theme) => ({
  headerCss: {
    padding: "2rem",
    alignItems: "center",
  },
  headerColor: { color: theme.palette.MDCColors.black },
  contentCss: {
    fontFamily: theme.palette.typography.fontFamily,
    color: theme.palette.MDCColors.color15,
    padding: "0 2rem",
  },
}));

const MessageDetailsDialog = (props) => {
  const { headerCss, headerColor, contentCss } = useStyles();

  const { popUpHeading, messages, show, handlePopupClose, status } = props;

  const getModalHeader = () => {
    return (
      <Grid container className={headerCss}>
        <Grid item xs={8} className={headerColor}>
          <h2>{popUpHeading}</h2>
        </Grid>
        <Grid item xs={4}>
          <img alt="My Digital Car" src={carLogo} width="95%" />
        </Grid>
      </Grid>
    );
  };

  const getModalBody = () => {
    return (
      <Grid
        container
        className={contentCss}
        overflow={"auto"}
        marginBottom={"1rem"}
        marginTop={"1rem"}
      >
        {messages?.map((messageDetails, index) => {
          return (
            <Grid key={index} container marginBottom={"1rem"}>
              <Grid item xs={0.5}>
                {status === GLOBAL_MESSAGE_STATUS.INFO && (
                  <>
                    <YellowWarningIcon />
                  </>
                )}
                {status === GLOBAL_MESSAGE_STATUS.SUCCESS && (
                  <SuccessTickIcon
                    color={theme.palette.MDCColors.errorSuccess}
                  />
                )}
                {status === GLOBAL_MESSAGE_STATUS.ERROR && (
                  <ErrorFilterIcon
                    color={theme.palette.MDCColors.errorSuccess}
                  />
                )}
              </Grid>
              <Grid item xs={11.5}>
                {messageDetails?.message}
                {<br />}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const getModalFooter = () => {
    return (
      <Grid container pb={3} paddingX={"2rem"} justifyContent="flex-end">
        <Grid item>
          <MDCButton
            onClick={handlePopupClose}
            variant="outlined"
            label="Schließen"
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <div>
      <MDCModal
        open={show}
        title={getModalHeader()}
        body={getModalBody()}
        footer={getModalFooter()}
        size="lg"
        isScroll
      />
    </div>
  );
};

export default MessageDetailsDialog;
